import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css'
import './fonts/Trap-ExtraBold.otf';
import './fonts/Trap-Black.otf'
import './fonts/Trap-Light.otf'
import './fonts/Trap-Medium.otf'
import './fonts/Trap-Regular.otf'
import './fonts/Trap-Bold.otf'
import './fonts/Trap-SemiBold.otf'

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
